/*
  Icon Walls — Collection
  - Infinite Scroll: lädt die nächste Seite automatisch, sobald das Seitenende
    in die Nähe kommt (IntersectionObserver, 800px Vorlauf). Der „Mehr laden"-
    Button bleibt als Fallback (kein IO / JS-Fehler) und als Lade-Indikator.
  - Load-More-Klick: hängt die nächste Seite per fetch an (progressive enhancement)
  - Filter: submittet das GET-Formular bei Änderung (native Storefront-Filter)
*/
(function () {
  'use strict';

  function initLoadMore(root) {
    var grid = root.querySelector('[data-iw-grid]');
    if (!grid) return;

    function loadNext(btn) {
      var url = btn.getAttribute('href');
      if (!url || btn.classList.contains('is-loading')) return Promise.resolve(false);
      btn.classList.add('is-loading');
      btn.textContent = '…';

      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('[data-iw-grid] [data-iw-card]');
          newCards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
          var nextBtn = doc.querySelector('[data-iw-loadmore]');
          if (nextBtn) {
            btn.setAttribute('href', nextBtn.getAttribute('href'));
            btn.classList.remove('is-loading');
            btn.textContent = nextBtn.textContent.trim();
          } else {
            var wrap = btn.closest('.iw-coll__more');
            if (wrap) wrap.remove(); else btn.remove();
          }
          // Reveal für neu geladene Karten anstoßen
          if (window.requestAnimationFrame) {
            requestAnimationFrame(function () {
              grid.querySelectorAll('.iw-reveal').forEach(function (el) { el.classList.add('iw-in'); });
            });
          }
          return true;
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.textContent = 'Mehr laden';
          return false;
        });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-iw-loadmore]');
      if (!btn) return;
      e.preventDefault();
      loadNext(btn);
    });

    // Infinite Scroll: automatisch weiterladen, sobald der Button in die Nähe rückt.
    var btn = root.querySelector('[data-iw-loadmore]');
    if (!btn || !('IntersectionObserver' in window)) return;
    var busy = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || busy) return;
        busy = true;
        loadNext(btn).then(function () {
          busy = false;
          if (!document.body.contains(btn)) { io.disconnect(); return; }
          // Ziel neu bewerten: liegt der Button weiterhin im Vorlauf-Bereich,
          // feuert der Observer erneut → nahtlose Kette bis zur letzten Seite.
          io.unobserve(btn);
          io.observe(btn);
        });
      });
    }, { rootMargin: '0px 0px 800px 0px' });
    io.observe(btn);
  }

  function initFilters(root) {
    var form = root.querySelector('[data-iw-filter-form]');
    if (!form) return;
    form.addEventListener('change', function (e) {
      // Preis-Inputs erst per Button anwenden
      if (e.target.type === 'number') return;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  // Material-Handoff: kommt der Kunde aus dem Homepage-Material-Filter
  // (…/collections/x?material=slug), hängen wir das Material an alle Produktlinks
  // → die PDP wählt es vor. Zusätzlich ein Kontext-Chip zum Zurücksetzen.
  var MAT_LABELS = {
    'leinwand': 'Leinwand', 'acryl': 'Acryl', 'aluminium': 'Aluminium',
    'geb-alu': 'Gebürstetes Aluminium',
    'poster-museum-matt': 'Poster Museum (matt)',
    'poster-premium': 'Poster Premium', 'poster-premium-matt': 'Poster Premium (matt)',
    'poster-klassisch': 'Poster Klassisch', 'poster-klassisch-matt': 'Poster Klassisch (matt)'
  };
  function initMaterialHandoff(root) {
    var params = new URLSearchParams(window.location.search);
    var mat = params.get('material');
    if (!mat) return;

    function tagWithin(scope) {
      var links = scope.querySelectorAll('[data-iw-card] a[href*="/products/"]');
      links.forEach(function (a) {
        var href = a.getAttribute('href');
        if (!href || href.indexOf('material=') !== -1) return;
        a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'material=' + encodeURIComponent(mat));
      });
    }
    tagWithin(root);

    // Neu geladene Karten (Infinite Scroll) ebenfalls taggen
    var grid = root.querySelector('[data-iw-grid]');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches('[data-iw-card]')) tagWithin(n.parentNode || grid);
            else tagWithin(n);
          });
        });
      }).observe(grid, { childList: true });
    }

    // Kontext-Chip über dem Grid
    if (grid && !root.querySelector('[data-iw-matnote]')) {
      var label = MAT_LABELS[mat] || (mat.charAt(0).toUpperCase() + mat.slice(1));
      var note = document.createElement('div');
      note.className = 'iw-coll__matnote';
      note.setAttribute('data-iw-matnote', '');
      var base = window.location.pathname;
      note.innerHTML = '<span class="iw-coll__matnote-label">Material: <b>' + label + '</b></span>' +
        '<a class="iw-coll__matnote-clear" href="' + base + '">zurücksetzen</a>';
      grid.parentNode.insertBefore(note, grid);
    }
  }

  function boot() {
    document.querySelectorAll('.iw-coll').forEach(function (root) {
      initLoadMore(root);
      initFilters(root);
      initMaterialHandoff(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
